module.exports = __webpack_public_path__ + "img/kcell.c9662b36.svg";